import { type ErrorEvent } from '@sentry/vue'

import filterLegacyErrors from './filters/filterLegacyErrors'

const filteringRules = [
  filterLegacyErrors,
]

/**
 * Apply error rules to determine which errors we should send
 * to Sentry
 */
export function shouldAcceptSentryEvent(error: ErrorEvent) {
  return filteringRules.every(rule => rule(error))
}
